'use strict';

var React = require('react');

var SvgMergeMinor = function SvgMergeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.75 17a.75.75 0 0 1-.75-.75v-1.695a3.75 3.75 0 0 1 1.587-3.064l2.134-1.506a1.25 1.25 0 0 0 .529-1.021v-4.001l-1.991 1.838a.75.75 0 1 1-1.018-1.102l3.25-3a.75.75 0 0 1 1.018 0l3.25 3a.75.75 0 1 1-1.018 1.102l-1.991-1.838v4a2.75 2.75 0 0 1-1.164 2.247l-2.134 1.506a2.25 2.25 0 0 0-.952 1.839v1.695a.75.75 0 0 1-.75.75Zm8.5 0a.75.75 0 0 1-.75-.75v-1.695a2.25 2.25 0 0 0-.953-1.839l-.854-.603a.75.75 0 1 1 .864-1.226l.856.604a3.75 3.75 0 0 1 1.587 3.064v1.695a.75.75 0 0 1-.75.75Z"
  }));
};
SvgMergeMinor.displayName = "MergeMinor";

exports.SvgMergeMinor = SvgMergeMinor;
